import { getWeekBottomElements } from './get-week-bottom-elements';
import { getWeekFormattedTimeframes } from './get-week-formatted-timeframes';
import { getWeekTimeframes } from './get-week-timeframes';
import { getWeekTopElements } from './get-week-top-elements';
import { TTimelineColumns } from './timeline-timeframes';

// --------------------------------------------------
// --------------------- WEEK -----------------------
// --------------------------------------------------

export function setWeek(from: Date, to: Date): TTimelineColumns {
  return {
    topWidth: 147,
    bottomWidth: 98,

    topElements: getWeekTopElements(from, to),
    bottomElements: getWeekBottomElements(from, to),
    timeframes: getWeekTimeframes(from, to),
    formattedTimeframes: getWeekFormattedTimeframes(from, to),
  };
}
